// extracted by mini-css-extract-plugin
module.exports = {"green":"deposit_green__dnorI","notHighlighted":"deposit_notHighlighted__F4LX2"};